import { GridItem, HStack, Text, useTheme, VStack } from '@chakra-ui/react';
import React from 'react'
import { useAppContext } from '../../../App';

export default function DiscountCard({item}) {   
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  const getImage = () => {
    return item.img.includes('http')? item.img : require(`../../../innerAsstes/benefits/${item.img}`) || null
  }
  return (
    <GridItem
      key={item.id}
      p={isMobile? 0:4}
      borderRadius="md"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={"100%"}
      borderBottom={"1px solid"}
      borderBottomRadius={0}
      borderBottomColor={theme.color.text.primary}
    >
      <HStack display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <img src={getImage()} style={style.square}/>
        <VStack align="flex-start" spacing={2} width={"70%"}>
          <Text
            fontWeight="bold"
            fontSize={isMobile? "1rem":"1rem"}
            color={theme.color.text.secondary}
          >
            {item.title}
          </Text>
          <Text fontSize={isMobile? "1rem":"0.5rem"} color={theme.color.text.primary}>
            Válido hasta {item.date}
          </Text>
        </VStack>
      </HStack>
    </GridItem>
  );
}
const styles = (theme, isMobile) => ({
  square: {
    width: isMobile ? "10vh" : "20vh",
    height: isMobile ? "10vh" : "20vh",
    border: "1px solid",
    borderColor: theme.color.text.secondary,
    margin: "0 10px",
  },
});